import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export interface User {
  id: string
  name: string
  email: string
  access: string // 权限
  avatar?: string
  shopId: number
  level: number
  isIdentity: number
  isEmail: number
  invite: string,
  bg: string,
  gender: number
}

export const useUserStore = defineStore('user', () => {
  // 状态
  const user = ref<User | null>(null)
  const isLoggedIn = ref(false)
  const loading = ref(false)

  // 计算属性
  const userName = computed(() => user.value?.name || '未登录')
  const userEmail = computed(() => user.value?.email || '')
  const userAvatar = computed(() => user.value?.avatar || 'https://ttou.j03og.app/uc_server/images/noavatar_small.gif')

  const groupObj = ""; // 请求好友传参

  // 动作
  const setUser =  (obj: User) => {
    // console.log("login",obj)
      user.value = obj
  }

  const logout = () => {
    user.value = null
    isLoggedIn.value = false
  }

  const updateProfile = (profileData: Partial<User>) => {
    if (user.value) {
      user.value = { ...user.value, ...profileData }
    }
  }

  const clearProfile = () => {
    if (user.value) {
      user.value = { id:'',name:"",email:'',avatar:'',access:'',shopId:0, level: 0,isEmail:0,isIdentity:0,invite:"",gender:0,bg:""}
    }
  }

  return {
    // 状态
    user,
    isLoggedIn,
    loading,
    // 计算属性
    userName,
    userEmail,
    userAvatar,

    groupObj,
    // 动作
    setUser,
    logout,
    updateProfile,
    clearProfile
  }
})
